var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListSvgrepoCom1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.9,47.5l6.5-3.2l-17.6-6.5l6.5,17.6l3.2-6.5l6.8,6.8c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L47.9,47.5z M40.1,41.1l9.2,3.4l-3.9,1.9l-1.9,3.9L40.1,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28,14h18c0.6,0,1-0.4,1-1s-0.4-1-1-1H28c-0.6,0-1,0.4-1,1S27.4,14,28,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28,28h18c0.6,0,1-0.4,1-1s-0.4-1-1-1H28c-0.6,0-1,0.4-1,1S27.4,28,28,28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.6,7.2c-0.4-0.4-1.1-0.3-1.4,0.1l-6.2,7.3l-3.8-2.9C9.7,11.4,9,11.5,8.7,12c-0.3,0.4-0.2,1.1,0.2,1.4 l4.6,3.4c0.2,0.1,0.4,0.2,0.6,0.2c0.3,0,0.6-0.1,0.8-0.4l6.9-8C22,8.2,22,7.6,21.6,7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.6,21.2c-0.4-0.4-1.1-0.3-1.4,0.1l-6.2,7.3l-3.8-2.9C9.7,25.4,9,25.5,8.7,26c-0.3,0.4-0.2,1.1,0.2,1.4 l4.6,3.4c0.2,0.1,0.4,0.2,0.6,0.2c0.3,0,0.6-0.1,0.8-0.4l6.9-8C22,22.2,22,21.6,21.6,21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.2,36.3l-6.2,7.3l-3.8-2.9C9.7,40.4,9,40.5,8.7,41c-0.3,0.4-0.2,1.1,0.2,1.4l4.6,3.4 c0.2,0.1,0.4,0.2,0.6,0.2c0.3,0,0.6-0.1,0.8-0.3l6.9-8c0.4-0.4,0.3-1-0.1-1.4C21.2,35.9,20.5,35.9,20.2,36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.8,0H13.2C6.5,0,1,5.5,1,12.2v29.6C1,48.5,6.5,54,13.2,54H33c0.6,0,1-0.4,1-1s-0.4-1-1-1H13.2 C7.6,52,3,47.4,3,41.8V12.2C3,6.6,7.6,2,13.2,2h29.6C48.4,2,53,6.6,53,12.2V37c0,0.6,0.4,1,1,1s1-0.4,1-1V12.2 C55,5.5,49.5,0,42.8,0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListSvgrepoCom1);
export default __webpack_public_path__ + "static/media/list-svgrepo-com1.00657c2ee8011c88e3024d6652265ea1.svg";
export { ForwardRef as ReactComponent };